export default __webpack_public_path__ + "static/media/licence_and_carrier_free.0724d38f.svg";